const servicesDictionary = {
	"bravas": "Bravas",
	"bravas.events": "Eventos",
	"bravas.events.device": "Dispositivo",
	"bravas.events.device.getByModule": "Buscar por módulo",
	"bravas.events.device.getByModulePaginated": "Buscar por módulo com paginação",
	"bravas.events.device.get*": "Todas visualizações",
	"bravas.events.device.downloadCSV": "Baixar CSV",
	"bravas.events.device.update": "Atualizar",
	"bravas.events.notificationBadge": "Notificação",
	"bravas.events.notificationBadge.getByModule": "Buscar por módulo",
	"bravas.events.notificationBadge.update": "Atualizar",

	"bravas.accessManagement": "(CLOUD) Controle de Acesso",
	"bravas.accessManagement.group": "Grupo",
	"bravas.accessManagement.group.create": "Criar",
	"bravas.accessManagement.group.update": "Atualizar",
	"bravas.accessManagement.group.delete": "Excluir",
	"bravas.accessManagement.group.getAll": "Buscar todos",
	"bravas.accessManagement.group.getById": "Buscar por ID",
	"bravas.accessManagement.group.getPaginated": "Buscar com paginação",
	"bravas.accessManagement.group.get*": "Todas visualizações",
	"bravas.accessManagement.policy": "Política",
	"bravas.accessManagement.policy.create": "Criar",
	"bravas.accessManagement.policy.update": "Atualizar",
	"bravas.accessManagement.policy.delete": "Excluir",
	"bravas.accessManagement.policy.getAll": "Buscar todos",
	"bravas.accessManagement.policy.getById": "Buscar por ID",
	"bravas.accessManagement.policy.getPaginated": "Buscar com paginação",
	"bravas.accessManagement.policy.get*": "Todas visualizações",
	"bravas.accessManagement.role": "Perfil",
	"bravas.accessManagement.role.create": "Criar",
	"bravas.accessManagement.role.update": "Atualizar",
	"bravas.accessManagement.role.delete": "Excluir",
	"bravas.accessManagement.role.getAll": "Buscar todos",
	"bravas.accessManagement.role.getById": "Buscar por ID",
	"bravas.accessManagement.role.getPaginated": "Buscar com paginação",
	"bravas.accessManagement.role.get*": "Todas visualizações",
	"bravas.accessManagement.role.addToUser": "Adicionar ao usuário",
	"bravas.accessManagement.role.removeFromUser": "Remover do usuário",
	"bravas.accessManagement.user": "Usuário",
	"bravas.accessManagement.user.create": "Criar",
	"bravas.accessManagement.user.update": "Atualizar",
	"bravas.accessManagement.user.delete": "Excluir",
	"bravas.accessManagement.user.getAll": "Buscar todos",
	"bravas.accessManagement.user.getPaginated": "Buscar com paginação",
	"bravas.accessManagement.user.getById": "Buscar por ID",
	"bravas.accessManagement.user.get*": "Todas visualizações",
	"bravas.accessManagement.user.addGroupToUser": "Adicionar grupo ao usuário",

	"bravas.identity": "Identidade",
	"bravas.identity.organization": "Organização",
	"bravas.identity.organization.create": "Criar",
	"bravas.identity.organization.update": "Atualizar (Completo)",
	"bravas.identity.organization.partialUpdate": "Atualizar",
	"bravas.identity.organization.delete": "Excluir",
	"bravas.identity.organization.getAll": "Buscar todos",
	"bravas.identity.organization.getPaginated": "Buscar com paginação",
	"bravas.identity.organization.getById": "Buscar por ID",
	"bravas.identity.organization.get*": "Todas visualizações",
	"bravas.identity.person": "Pessoa",
	"bravas.identity.person.create": "Criar",
	"bravas.identity.person.update": "Atualizar",
	"bravas.identity.person.delete": "Excluir",
	"bravas.identity.person.getAll": "Buscar todos",
	"bravas.identity.person.getById": "Buscar por ID",
	"bravas.identity.person.getPaginated": "Buscar com paginação",
	"bravas.identity.person.get*": "Todas visualizações",
	"bravas.identity.shift": "Turno",
	"bravas.identity.shift.create": "Criar",
	"bravas.identity.shift.update": "Atualizar",
	"bravas.identity.shift.delete": "Excluir",
	"bravas.identity.shift.getAll": "Buscar todos",
	"bravas.identity.shift.getPaginated": "Buscar com paginação",
	"bravas.identity.shift.getById": "Buscar por ID",
	"bravas.identity.shift.get*": "Todas visualizações",
	"bravas.identity.tag": "Etiqueta",
	"bravas.identity.tag.create": "Criar",
	"bravas.identity.tag.update": "Atualizar",
	"bravas.identity.tag.delete": "Excluir",
	"bravas.identity.tag.getAll": "Buscar todos",
	"bravas.identity.tag.getByType": "Buscar por tipo",
	"bravas.identity.tag.getByOrganization": "Buscar por organização",
	"bravas.identity.tag.getPaginated": "Buscar com paginação",
	"bravas.identity.tag.get*": "Todas visualizações",
	"bravas.identity.unit": "Unidade",
	"bravas.identity.unit.create": "Criar",
	"bravas.identity.unit.update": "Atualizar",
	"bravas.identity.unit.delete": "Excluir",
	"bravas.identity.unit.getAll": "Buscar todos",
	"bravas.identity.unit.getPaginated": "Buscar com paginação",
	"bravas.identity.unit.getById": "Buscar por ID",
	"bravas.identity.unit.get*": "Todas visualizações",

	"bravas.accessControl": "Controle de Acesso",
	"bravas.accessControl.command": "Comando",
	"bravas.accessControl.command.automCmd": "Comando de automação",
	"bravas.accessControl.command.pgmCmd": "Comando de PGM",
	"bravas.accessControl.command.accessCmd": "Comando de acesso",
	"bravas.accessControl.accessModule": "Módulo de Acesso",
	"bravas.accessControl.accessModule.get*": "Todas visualizações",
	"bravas.accessControl.accessModule.getAll": "Buscar todos",
	"bravas.accessControl.accessModule.getPaginated": "Buscar com paginação",
	"bravas.accessControl.accessModule.getByUnitAndLicense": "Buscar por unidade e licença",
	"bravas.accessControl.accessModule.getByUnit": "Buscar por unidade",
	"bravas.accessControl.accessModule.getById": "Buscar por ID",
	"bravas.accessControl.accessModule.create": "Criar",
	"bravas.accessControl.accessModule.bulkCreate": "Criar em lote",
	"bravas.accessControl.accessModule.update": "Atualizar",
	"bravas.accessControl.accessModule.delete": "Excluir",
	"bravas.accessControl.accessModule.resyncById": "Ressincronizar por ID",
	"bravas.accessControl.accessModule.resyncAll": "Ressincronizar todos",
	"bravas.accessControl.accessPoint": "Ponto de Acesso",
	"bravas.accessControl.automationButton": "Botão de Automação",
	"bravas.accessControl.automationButton.getPaginated": "Buscar com paginação",
	"bravas.accessControl.automationButton.getAll": "Buscar todos",
	"bravas.accessControl.automationButton.getByUnit": "Buscar por unidade",
	"bravas.accessControl.automationButton.getById": "Buscar por ID",
	"bravas.accessControl.automationButton.get*": "Todas visualizações",
	"bravas.accessControl.automationButton.create": "Criar",
	"bravas.accessControl.automationButton.update": "Atualizar",
	"bravas.accessControl.automationButton.delete": "Excluir",
	"bravas.accessControl.reader": "Leitora IP",
	"bravas.accessControl.reader.getPaginated": "Buscar com paginação",
	"bravas.accessControl.reader.getAll": "Buscar todos",
	"bravas.accessControl.reader.getById": "Buscar por ID",
	"bravas.accessControl.reader.get*": "Todas visualizações",
	"bravas.accessControl.reader.create": "Criar",
	"bravas.accessControl.reader.deleteAllUsersOperation": "Deletar todos usuários",
	"bravas.accessControl.reader.deleteUserOperation": "Deletar um usuário",
	"bravas.accessControl.reader.syncAllUsersOperation": "Sincronizar todos usuários",
	"bravas.accessControl.reader.adjust": "Ajustar",
	"bravas.accessControl.reader.syncUserOperation": "Sincronizar usuário",
	"bravas.accessControl.reader.getStates": "Buscar estados",
	"bravas.accessControl.reader.getServices": "Buscar serviços",
	"bravas.accessControl.reader.updateServices": "Atualizar serviços",
	"bravas.accessControl.reader.bulkCreate": "Criar em lote",
	"bravas.accessControl.reader.update": "Atualizar",
	"bravas.accessControl.reader.delete": "Excluir",
	"bravas.accessControl.interlock": "Intertravamento",
	"bravas.accessControl.interlock.get*": "Todas visualizações",
	"bravas.accessControl.interlock.getAll": "Buscar todos",
	"bravas.accessControl.interlock.getPaginated": "Buscar com paginação",
	"bravas.accessControl.interlock.getByUnitAndLicense": "Buscar por unidade e licença",
	"bravas.accessControl.interlock.getByUnit": "Buscar por unidade",
	"bravas.accessControl.interlock.getById": "Buscar por ID",
	"bravas.accessControl.interlock.create": "Criar",
	"bravas.accessControl.interlock.bulkCreate": "Criar em lote",
	"bravas.accessControl.interlock.update": "Atualizar",
	"bravas.accessControl.interlock.delete": "Excluir",
	"bravas.accessControl.interlock.resyncById": "Ressincronizar por ID",
	"bravas.accessControl.interlock.resyncAll": "Ressincronizar todos",
	"bravas.accessControl.antiPassback": "Anti Passback",
	"bravas.accessControl.antiPassback.get*": "Todas visualizações",
	"bravas.accessControl.antiPassback.getAll": "Buscar todos",
	"bravas.accessControl.antiPassback.getPaginated": "Buscar com paginação",
	"bravas.accessControl.antiPassback.getByUnitAndLicense": "Buscar por unidade e licença",
	"bravas.accessControl.antiPassback.getByUnit": "Buscar por unidade",
	"bravas.accessControl.antiPassback.getById": "Buscar por ID",
	"bravas.accessControl.antiPassback.create": "Criar",
	"bravas.accessControl.antiPassback.bulkCreate": "Criar em lote",
	"bravas.accessControl.antiPassback.update": "Atualizar",
	"bravas.accessControl.antiPassback.delete": "Excluir",
	"bravas.accessControl.antiPassback.resyncById": "Ressincronizar por ID",
	"bravas.accessControl.antiPassback.resyncAll": "Ressincronizar todos",
	"bravas.accessControl.user": "Usuário de Acesso",
	"bravas.accessControl.user.getPaginated": "Buscar com paginação",
	"bravas.accessControl.user.getAll": "Buscar todos",
	"bravas.accessControl.user.getById": "Buscar por ID",
	"bravas.accessControl.user.get*": "Todas visualizações",
	"bravas.accessControl.user.create": "Criar",
	"bravas.accessControl.user.bulkCreate": "Criar em lote",
	"bravas.accessControl.user.update": "Atualizar",
	"bravas.accessControl.user.delete": "Excluir",
	"bravas.accessControl.credential": "Credencial",
	"bravas.accessControl.credential.getAll": "Buscar todos",
	"bravas.accessControl.credential.getPaginated": "Buscar com paginação",
	"bravas.accessControl.credential.getById": "Buscar por ID",
	"bravas.accessControl.credential.get*": "Todas visualizações",
	"bravas.accessControl.credential.getByUser": "Buscar por usuário",
	"bravas.accessControl.credential.create": "Criar",
	"bravas.accessControl.credential.update": "Atualizar",
	"bravas.accessControl.credential.delete": "Excluir",
	"bravas.accessControl.vehicle": "Veículo",
	"bravas.accessControl.vehicle.getAll": "Buscar todos",
	"bravas.accessControl.vehicle.getPaginated": "Buscar com paginação",
	"bravas.accessControl.vehicle.getByUser": "Buscar por usuário",
	"bravas.accessControl.vehicle.getById": "Buscar por ID",
	"bravas.accessControl.vehicle.get*": "Todas visualizações",
	"bravas.accessControl.vehicle.create": "Criar",
	"bravas.accessControl.vehicle.update": "Atualizar",
	"bravas.accessControl.vehicle.delete": "Excluir",
	"bravas.accessControl.group": "Grupo de Acesso",
	"bravas.accessControl.group.getAll": "Buscar todos",
	"bravas.accessControl.group.getPaginated": "Buscar com paginação",
	"bravas.accessControl.group.getByUnit": "Buscar por unidade",
	"bravas.accessControl.group.getById": "Buscar por ID",
	"bravas.accessControl.group.get*": "Todas visualizações",
	"bravas.accessControl.group.create": "Criar",
	"bravas.accessControl.group.bulkCreate": "Criar em lote",
	"bravas.accessControl.group.update": "Atualizar",
	"bravas.accessControl.group.delete": "Excluir",
	"bravas.accessControl.license": "Licença",
	"bravas.accessControl.license.getAll": "Buscar todos",
	"bravas.accessControl.license.getPaginated": "Buscar com paginação",
	"bravas.accessControl.license.getById": "Buscar por ID",
	"bravas.accessControl.license.getByOrganization": "Buscar por organização",
	"bravas.accessControl.license.getWithAccess": "Buscar com acesso",
	"bravas.accessControl.license.get*": "Todas visualizações",
	"bravas.accessControl.license.updateFromUnit": "Atualizar a partir da unidade",
	"bravas.accessControl.license.updateFromOrganization": "Atualizar a partir da organização",
	"bravas.accessControl.license.updateSnEquipment": "Atualizar a serial number do equipamento",
	"bravas.accessControl.license.create": "Criar",
	"bravas.accessControl.license.update": "Atualizar",
	"bravas.accessControl.license.delete": "Excluir",
	"bravas.accessControl.license.detailed": "Licenças detalhadas",
	"bravas.accessControl.license.detailed.getPaginated": "Buscar licenças detalhadas com paginação",
	"bravas.accessControl.license.detailed.exportCsv": "Exportar licenças para CSV",
	"bravas.accessControl.license.statesCount": "Consultar quantidade de licenças por status",
	"bravas.accessControl.license.analytics": "Consultar indicadores de licenças",
	"bravas.accessControl.license.discountReason": "Motivos de desconto",
	"bravas.accessControl.license.discountReason.getPaginated": "Buscar motivos de desconto com paginação",
	"bravas.accessControl.license.discountReason.getAll": "Buscar todos os motivos de desconto",
	"bravas.accessControl.license.discountReason.create": "Criar motivo de desconto",
	"bravas.accessControl.license.discountReason.update": "Atualizar motivo de desconto",
	"bravas.accessControl.license.discountReason.delete": "Excluir motivo de desconto",
	"bravas.accessControl.license.type": "Tipos de licença",
	"bravas.accessControl.license.type.getPaginated": "Buscar tipos de licença com paginação",
	"bravas.accessControl.license.type.getAll": "Buscar todos os tipos de licença",
	"bravas.accessControl.license.type.getById": "Buscar tipo de licença por ID",
	"bravas.accessControl.license.type.create": "Criar tipo de licença",
	"bravas.accessControl.license.type.update": "Atualizar tipo de licença",
	"bravas.accessControl.license.type.delete": "Excluir tipo de licença",
	"bravas.accessControl.license.feature": "Funcionalidades da licença",
	"bravas.accessControl.license.feature.getPaginated": "Buscar funcionalidades de licença com paginação",
	"bravas.accessControl.license.feature.getAll": "Buscar todas as funcionalidades de licença",
	"bravas.accessControl.license.feature.getById": "Buscar funcionalidade de licença por ID",
	"bravas.accessControl.license.feature.create": "Criar funcionalidade de licença",
	"bravas.accessControl.license.feature.update": "Atualizar funcionalidade de licença",
	"bravas.accessControl.license.feature.delete": "Excluir funcionalidade de licença",
	"bravas.accessControl.license.calculate": "Calcular valor da licença",
	"bravas.accessControl.license.billing": "Cobranças da licença",
	"bravas.accessControl.license.billing.getPaginated": "Buscar cobranças da licença com paginação",
	"bravas.accessControl.license.billing.create": "Criar cobrança da licença",
	"bravas.accessControl.license.billing.update": "Atualizar cobrança da licença",
	"bravas.accessControl.license.association": "Consultar associações da licença",
	"bravas.accessControl.license.history": "Consultar histórico da licença",
	"bravas.accessControl.license.action": "Consultar agendamentos da licença",
	"bravas.accessControl.license.payment": "Pagamentos da licença",
	"bravas.accessControl.license.payment.update": "Registrar pagamento da licença",
	"bravas.accessControl.license.transfer": "Transferir licença",
	"bravas.accessControl.license.changeFeatures": "Alterar funcionalidades da licença",
	"bravas.accessControl.license.bindingCode": "Atualizar código de vinculação da licença",
	"bravas.accessControl.license.allocate": "Alocar licença",
	"bravas.accessControl.license.block": "Agendar bloqueio da licença",
	"bravas.accessControl.license.unblock": "Agendar desbloqueio da licença",
	"bravas.accessControl.license.suspend": "Agendar suspensão da licença",
	"bravas.accessControl.license.rename": "Renomear licença",
	"bravas.accessControl.door": "Porta",
	"bravas.accessControl.door.getAll": "Buscar todos",
	"bravas.accessControl.door.getById": "Buscar por ID",
	"bravas.accessControl.door.getPaginated": "Buscar com paginação",
	"bravas.accessControl.door.get*": "Todas visualizações",
	"bravas.accessControl.door.create": "Criar",
	"bravas.accessControl.door.update": "Atualizar",
	"bravas.accessControl.door.delete": "Excluir",
	"bravas.accessControl.doorIp": "Porta IP",
	"bravas.accessControl.doorIp.getAll": "Buscar todos",
	"bravas.accessControl.doorIp.getById": "Buscar por ID",
	"bravas.accessControl.doorIp.getPaginated": "Buscar com paginação",
	"bravas.accessControl.doorIp.get*": "Todas visualizações",
	"bravas.accessControl.doorIp.create": "Criar",
	"bravas.accessControl.doorIp.update": "Atualizar",
	"bravas.accessControl.doorIp.delete": "Excluir",
	"bravas.accessControl.garage": "Garagem",
	"bravas.accessControl.garage.getAll": "Buscar todos",
	"bravas.accessControl.garage.getById": "Buscar por ID",
	"bravas.accessControl.garage.getPaginated": "Buscar com paginação",
	"bravas.accessControl.garage.get*": "Todas visualizações",
	"bravas.accessControl.garage.create": "Criar",
	"bravas.accessControl.garage.update": "Atualizar",
	"bravas.accessControl.garage.delete": "Excluir",
	"bravas.accessControl.garageIp": "Garagem IP",
	"bravas.accessControl.garageIp.getAll": "Buscar todos",
	"bravas.accessControl.garageIp.getById": "Buscar por ID",
	"bravas.accessControl.garageIp.getPaginated": "Buscar com paginação",
	"bravas.accessControl.garageIp.get*": "Todas visualizações",
	"bravas.accessControl.garageIp.create": "Criar",
	"bravas.accessControl.garageIp.update": "Atualizar",
	"bravas.accessControl.garageIp.delete": "Excluir",
	"bravas.accessControl.gate": "Portão",
	"bravas.accessControl.gate.getAll": "Buscar todos",
	"bravas.accessControl.gate.getById": "Buscar por ID",
	"bravas.accessControl.gate.getPaginated": "Buscar com paginação",
	"bravas.accessControl.gate.get*": "Todas visualizações",
	"bravas.accessControl.gate.create": "Criar",
	"bravas.accessControl.gate.update": "Atualizar",
	"bravas.accessControl.gate.delete": "Excluir",
	"bravas.accessControl.gateIp": "Portão IP",
	"bravas.accessControl.gateIp.getAll": "Buscar todos",
	"bravas.accessControl.gateIp.getById": "Buscar por ID",
	"bravas.accessControl.gateIp.getPaginated": "Buscar com paginação",
	"bravas.accessControl.gateIp.get*": "Todas visualizações",
	"bravas.accessControl.gateIp.create": "Criar",
	"bravas.accessControl.gateIp.update": "Atualizar",
	"bravas.accessControl.gateIp.delete": "Excluir",
	"bravas.accessControl.localDoor": "Porta Local",
	"bravas.accessControl.localDoor.getAll": "Buscar todos",
	"bravas.accessControl.localDoor.getById": "Buscar por ID",
	"bravas.accessControl.localDoor.getPaginated": "Buscar com paginação",
	"bravas.accessControl.localDoor.get*": "Todas visualizações",
	"bravas.accessControl.localDoor.create": "Criar",
	"bravas.accessControl.localDoor.update": "Atualizar",
	"bravas.accessControl.localDoor.delete": "Excluir",
	"bravas.accessControl.general": "Geral",
	"bravas.accessControl.general.reception": "Recepção",

	"bravas.backup": "Backup",
	"bravas.backup.config": "Configuração de backups",
	"bravas.backup.config.create": "Criar",
	"bravas.backup.config.update": "Atualizar",
	"bravas.backup.config.getByOrganization": "Buscar por organização",
	"bravas.backup.config.getByLicense": "Buscar por licença",
	"bravas.backup.management": "Gerenciamento de Backup",
	"bravas.backup.management.list": "Listar",
	"bravas.backup.management.download": "Baixar",
	"bravas.backup.management.import": "Importar na Cloud",
	"bravas.backup.management.upload": "Carregar",
	"bravas.backup.management.delete": "Excluir",

	"bravas.notifier": "Notificador",
	"bravas.notifier.configuration": "Configurações",
	"bravas.notifier.configuration.save": "Atualizar configurações",
	"bravas.notifier.webhook": "Webhooks",
	"bravas.notifier.webhook.get*": "Todas visualizações",
	"bravas.notifier.webhook.getPaginated": "Buscar com paginação",
	"bravas.notifier.webhook.create": "Criar",
	"bravas.notifier.webhook.update": "Atualizar",
	"bravas.notifier.webhook.delete": "Excluir",
	"bravas.notifier.organizationConfig": "Configurações de SMTP",
	"bravas.notifier.organizationConfig.get": "Buscar configurações de SMTP",
	"bravas.notifier.organizationConfig.update": "Atualizar configurações de SMTP",

	"bravas.apiGateway": "API Gateway",
	"bravas.apiGateway.log": "Log",
	"bravas.apiGateway.log.getAll": "Buscar todos",
	"bravas.apiGateway.log.get*": "Todas visualizações",
	"bravas.apiGateway.log.getPaginated": "Buscar com paginação",
	"bravas.apiGateway.log.downloadCSV": "Baixar CSV",
};

module.exports = {
	servicesDictionary
}